module.exports = __webpack_public_path__ + "img/suggest_0725.d4950586.png";